export enum CompareOperator {
  EQUAL,
  MORE,
  LESS,
  MORE_EQUAL,
  LESS_EQUAL,
}
